import { selectUserProfile } from '@glass/web/modules/auth';

const selectUserResumeDisplayName = (state) => selectUserProfile(state)?.phone || null;

export default selectUserResumeDisplayName;
